"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageResponseDealToJSON = exports.PageResponseDealFromJSONTyped = exports.PageResponseDealFromJSON = exports.instanceOfPageResponseDeal = void 0;
var Deal_1 = require("./Deal");
/**
 * Check if a given object implements the PageResponseDeal interface.
 */
function instanceOfPageResponseDeal(value) {
    var isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "totalElements" in value;
    isInstance = isInstance && "totalPages" in value;
    return isInstance;
}
exports.instanceOfPageResponseDeal = instanceOfPageResponseDeal;
function PageResponseDealFromJSON(json) {
    return PageResponseDealFromJSONTyped(json, false);
}
exports.PageResponseDealFromJSON = PageResponseDealFromJSON;
function PageResponseDealFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': (json['items'].map(Deal_1.DealFromJSON)),
        'page': json['page'],
        'size': json['size'],
        'totalElements': json['total_elements'],
        'totalPages': json['total_pages'],
    };
}
exports.PageResponseDealFromJSONTyped = PageResponseDealFromJSONTyped;
function PageResponseDealToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': (value.items.map(Deal_1.DealToJSON)),
        'page': value.page,
        'size': value.size,
        'total_elements': value.totalElements,
        'total_pages': value.totalPages,
    };
}
exports.PageResponseDealToJSON = PageResponseDealToJSON;
